import React, { useCallback, useContext, useState } from 'react';

import { useAppContext } from 'src/components/app-context';
import { ViewportContext } from 'src/components/viewport';
import { usePriceRowContext } from '../../../price-row-context';

import { Direction } from '@prisjakt/ui';
import { ButtonSize, ButtonType } from '@prisjakt/ui/button/variants';
import { DropdownContent, DropdownToggle } from '@prisjakt/ui/dropdown';
import { IconFlagOutlined } from '@prisjakt/ui/icon/flag-outlined';
import { ReportModal } from 'src/areas/product/components/price-list/price-row/components/report-modal';

import type { IOptionsColumn } from './types';

import * as RegularStyle from '../styles';
import { Dropdown, Option, Options, ReportOverlay } from './styles';

export const OptionsColumn: React.FC<
  React.PropsWithChildren<React.PropsWithChildren<IOptionsColumn>>
> = props => {
  const { alternativeOffer, className } = props;

  const { t } = useAppContext();
  const { isMobile } = useContext(ViewportContext);
  const {
    isFeatured,
    offer: { store },
    product,
  } = usePriceRowContext();

  const [modalIsOpen, setModalIsOpen] = useState(false);

  const openModal = useCallback(
    (e: React.MouseEvent) => {
      // Stops the PriceRow link and onClick from firing
      e.preventDefault();
      e.stopPropagation();

      setModalIsOpen(true);
    },
    [setModalIsOpen]
  );

  const closeModal = useCallback(() => setModalIsOpen(false), [setModalIsOpen]);

  return (
    <RegularStyle.Column className={className}>
      <ReportModal
        isOpen={modalIsOpen}
        closeModal={closeModal}
        priceId={alternativeOffer.id}
        priceValue={alternativeOffer.price?.exclShipping}
        productName={alternativeOffer.name}
        productImage={product.media?.first}
        stockStatus={alternativeOffer.stock?.status}
        isFeatured={isFeatured}
        store={store}
      />

      <Options>
        <Dropdown
          closeOnItemClick
          onToggle={(event: React.MouseEvent) => {
            event.stopPropagation();
            event.preventDefault();
          }}
        >
          <DropdownToggle
            onlyIcon
            size={ButtonSize.MEDIUM}
            type={ButtonType.TEXT}
          >
            <IconFlagOutlined color="base600" size={18} />
          </DropdownToggle>

          <DropdownContent placement={isMobile ? Direction.Up : Direction.Down}>
            <ReportOverlay>
              <Option type="button" onClick={openModal}>
                {t('feedback', 'dialog.prompt-button')}
              </Option>
            </ReportOverlay>
          </DropdownContent>
        </Dropdown>
      </Options>
    </RegularStyle.Column>
  );
};
